<template>
  <div>
    <div class="wrapper-parent">
      <carousel
        paginationActiveColor="#a5a5a599"
        paginationPadding="5"
        paginationSize="10"
        perPage="1"
        navigationEnabled="true"
        navigationNextLabel='<i class="fa fa-chevron-circle-right slide-nav"></i>'
        navigationPrevLabel='<i class="fa fa-chevron-circle-left slide-nav"></i>'
        navigationClickTargetSize="1"
        autoplay="true"
        autoplayTimeout="5000"
        centerMode="true"
        loop="true"
        paginationPosition="bottom-overlay"
      >
        <slide>
          <div class="cont zoom">
            <img src="@/assets/fotkeSlider/01.jpg" />
            <div class="centered centered-1"><p>Enjoy stunning views</p></div>
          </div>
        </slide>
        <slide>
          <div class="cont">
            <img src="@/assets/fotkeSlider/02.jpg" />
            <div class="centered centered-2"><p>Explore old towns</p></div>
          </div>
        </slide>
        <slide>
          <div class="cont">
            <img src="@/assets/fotkeSlider/03.jpg" />
            <div class="centered centered-3">Let's go higher</div>
          </div>
        </slide>
        <slide>
          <div class="cont">
            <img src="@/assets/fotkeSlider/04.jpg" />
            <div class="centered centered-4">Smell Montenegro</div>
          </div>
        </slide>
        <slide>
          <div class="cont">
            <img src="@/assets/fotkeSlider/05.jpg" />
            <div class="centered centered-5">Visit unique places</div>
          </div>
        </slide>
        <slide>
          <div class="cont">
            <img src="@/assets/fotkeSlider/06.jpg" />
            <div class="centered centered-6">Walk through the forest</div>
          </div>
        </slide>
        <slide>
          <div class="cont">
            <img src="@/assets/fotkeSlider/07 2.jpg" />
            <div class="centered centered-7">Experience diversity</div>
          </div>
        </slide>
      </carousel>
    </div>

    <div class="main-page-text container" id="main-page-text-container">
      <div class="main-row">
        <div class="col">
          <div class="row">
            <div class="main-text-column"></div>
            <div class="main-text">
              <div class="row"><h1>Natour & Cultour</h1></div>
              <br/>
              <div class="row">
                <div class="col-sm">
                  <p>
                    We have divided our tours into two segments – natour and
                    cultour, depending on what kind of offer they focus on –
                    whether on natural values or cultural heritage, but each of
                    them represents a unique and well balanced combination of
                    these two segments.
                  </p>
                </div>
                <div class="col-sm">
                  <p>
                    A glimpse into history, visits to interesting cultural and
                    historical localities, geographical and geological
                    particularities, stunning nature and photo spots, but we
                    surely will not miss the chance to smell local flowers and
                    check local bird world, meet the local folklore and way of
                    living and, of course, taste a gastronomic offer and the
                    best local drinks.
                  </p>
                </div>
                <div class="col-sm">
                  <p>
                    We want to share with you our enthusiasm, passion and love
                    for Montenegro, to walk you through Montenegro’s paths, old
                    towns, forests and meadows, introduce you to some
                    interesting locals with exciting stories to tell, revive
                    winds whipping Montenegro’s vastness over centuries and
                    ultimately - be as close as possible to what Montenegro is
                    today.
                  </p>
                </div>
                <div class="col-sm">
                  <p>
                  When creating our tours, we will do our best to leave as little carbon footprint as possible and show respect and support for local communities.
                  </p>
                  <br/>
                  <p
                  style="
                    width: 100%;
                    color: #31882b;
                    font-weight: bold;
                  "
                >
                  Welcome to Montenegro!
                </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row"><h1 class="page1">Multi-day tours</h1></div>
    <div class="wrapper-parent tour-slider" style="margin: 0px 20px">
      <carousel
        paginationEnabled="false"
        paginationActiveColor=""
        paginationColor=""
        paginationPadding=""
        paginationSize="0"
        v-bind:per-page-custom="[
          [180, 1],
          [450, 2],
          [780, 3],
        ]"
        navigationEnabled="true"
        navigationNextLabel='<i class="fa fa-chevron-right slide-nav"></i>'
        navigationPrevLabel='<i class="fa fa-chevron-left slide-nav"></i>'
        navigationClickTargetSize="1"
        autoplay="true"
        autoplayTimeout="5000"
        centerMode="true"
        loop="true"
        paginationPosition="bottom-overlay"
      >
        <slide>
          <div class="cont2">
            <a href="/multidaytour1" class="tour-link">
              <img src="@/assets/multidaytours/tour1/011.jpg" />
              <div class="tour-border">
                <p class="tour-name">Amazing north of Montenegro</p>
                <p class="tour-info">From <span>1350 &euro;</span></p>
                <p class="tour-info">8 days / 7 nights</p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/multidaytour2" class="tour-link">
              <img src="@/assets/multidaytours/tour2/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">5 Days in 5 National Parks</p>
                <p class="tour-info">From <span>1050 &euro;</span></p>
                <p class="tour-info">6 days / 5 nights</p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
        <slide>
          <div class='cont2'>
            <a href='/multidaytour3' class='tour-link'>
              <img src='@/assets/multidaytours/tour3/011.jpg' />
              <div class='tour-border'>
                <p class='tour-name'>Magnificent Durmitor NP</p>
                <p class='tour-info'>From <span>750 &euro;</span></p>
                <p class='tour-info'>5 days / 4 nights</p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/cultour4" class="tour-link">
              <img src="@/assets/cultours/tour4/011.jpg" />
              <div class="tour-border">
                <p class="tour-name">Through villages and old towns</p>
                <p class="tour-info">From <span>700 &euro;</span></p>
                <p class="tour-info">5 days / 4 nights</p>
              </div>
            </a>
            <div class="top-right-cul">CULTOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/cultour5" class="tour-link">
              <img src="@/assets/cultours/tour5/011.jpg" />
              <div class="tour-border">
                <p class="tour-name">Experience UNESCO’s Montenegro</p>
                <p class="tour-info">From <span>900 &euro;</span></p>
                <p class="tour-info">6 days / 5 nights</p>
              </div>
            </a>
            <div class="top-right-cul">CULTOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/cultour6" class="tour-link">
              <img src="@/assets/cultours/tour6/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">Katun fairy tale & old traditions</p>
                <p class="tour-info">From <span>1200 &euro;</span></p>
                <p class="tour-info">7 days / 6 nights</p>
              </div>
            </a>
            <div class="top-right-cul">CULTOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/ruraltour1" class="tour-link">
              <img src="@/assets/rural/tour1/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">Rural Montenegro</p>
                <p class="tour-info">From <span>1700 &euro;</span></p>
                <p class="tour-info">10 days / 9 nights</p>
              </div>
            </a>
            <div class="top-right-cul">RURAL</div>
          </div>
        </slide>
      </carousel>
    </div>

    <div class="row" style="margin-top: 20px">
      <h1 class="page1">Day trips</h1>
    </div>
    <div class="wrapper-parent tour-slider" style="margin: 0px 20px">
      <carousel
        paginationEnabled="false"
        paginationActiveColor=""
        paginationColor=""
        paginationPadding=""
        paginationSize="0"
        v-bind:per-page-custom="[
          [180, 1],
          [450, 2],
          [780, 3],
        ]"
        navigationEnabled="true"
        navigationNextLabel='<i class="fa fa-chevron-right slide-nav"></i>'
        navigationPrevLabel='<i class="fa fa-chevron-left slide-nav"></i>'
        navigationClickTargetSize="1"
        autoplay="true"
        autoplayTimeout="5000"
        centerMode="true"
        loop="true"
        paginationPosition="bottom-overlay"
      >
        <slide>
          <div class="cont2">
            <a href="/daytour1" class="tour-link">
              <img src="@/assets/daytours/tour1/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">
                  Through Moraca & Tara canyons and 2 national parks
                </p>
                <p class="tour-info">From <span>75 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/daytour2" class="tour-link">
              <img src="@/assets/daytours/tour2/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">
                  Circle around Korita (through Kuci Gate)
                </p>
                <p class="tour-info">From <span>50 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/daytour3" class="tour-link">
              <img src="@/assets/daytours/tour3/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">Canyon, old forest & cheese</p>
                <p class="tour-info">From <span>80 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/daytour4" class="tour-link">
              <img src="@/assets/daytours/tour4/011.jpg" />
              <div class="tour-border">
                <p class="tour-name">Natural Beauties of Old Montenegro</p>
                <p class="tour-info">From <span>65 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/daytour5" class="tour-link">
              <img src="@/assets/daytours/tour5/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">
                  Among Katuns, Shepherds and Geological Miracles
                </p>
                <p class="tour-info">From <span>70 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/cultour1" class="tour-link">
              <img src="@/assets/cultours/tour1/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">
                  Stećci tour – Mistery surrounded by beauty
                </p>
                <p class="tour-info">From <span>70 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-cul">CULTOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/cultour2" class="tour-link">
              <img src="@/assets/cultours/tour2/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">
                  Podgorica and its surroundings (through the centuries and
                  today)
                </p>
                <p class="tour-info">From <span>45 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-cul">CULTOUR</div>
          </div>
        </slide>
        <slide>
          <div class="cont2">
            <a href="/cultour3" class="tour-link">
              <img src="@/assets/cultours/tour3/011.jpg" />
              <div class="tour-border">
                <p class="tour-name">
                  Along UNESCO Bay - Kotor and its surroundings
                </p>
                <p class="tour-info">From <span>70 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-cul">CULTOUR</div>
          </div>
        </slide>
         <slide>
          <div class="cont2">
            <a href="/daytour6" class="tour-link">
              <img src="@/assets/daytours/tour6/01.jpg" />
              <div class="tour-border">
                <p class="tour-name">
                 Skadar Lake National Park - Among lilies, birds and ancient walls
                </p>
                <p class="tour-info">From <span>70 &euro;</span></p>
              </div>
            </a>
            <div class="top-right-nat">NATOUR</div>
          </div>
        </slide>
      </carousel>
    </div>

    <div class="reviews">
      <div class="row"><h1 class="page1">Told about us</h1></div>
      <div class="row">
        <div class="col-md review-col">
          <p class="reviewer">Zsófia T, November 2025</p>
          <p class="review">
            Great tour with insightful guidance
          </p>
          <button
            class="btn btn-review-more"
            data-toggle="modal"
            data-target="#reviewModal75"
          >
            READ MORE
          </button>
        </div>
        <div class="col-md review-col">
          <p class="reviewer">Manwai, September 2025</p>
          <p class="review">Our tour guide Nino was excellent...</p>
          <button
            class="btn btn-review-more"
            data-toggle="modal"
            data-target="#reviewModal74"
          >
            READ MORE
          </button>
        </div>
        <div class="col-md review-col">
          <p class="reviewer">BEATRICE_R, August 2025</p>
          <p class="review">Tour riche en découverte...</p>
          <button
            class="btn btn-review-more"
            data-toggle="modal"
            data-target="#reviewModal73"
          >
            READ MORE
          </button>
        </div>
    </div>

    <div class="row">
      <div class="col-md review-col">
        <p class="reviewer">Andrei, July 2025</p>
        <p class="review">
          Wonderful exploration of the beautiful Highlands of Montenegro
        </p>
        <button
          class="btn btn-review-more"
          data-toggle="modal"
          data-target="#reviewModal72"
        >
          READ MORE
        </button>
      </div>
      <div class="col-md review-col">
        <p class="reviewer">Dorothy & John, July 2025</p>
        <p class="review">Great private tour company at reasonable price</p>
        <button
          class="btn btn-review-more"
          data-toggle="modal"
          data-target="#reviewModal71"
        >
          READ MORE
        </button>
      </div>
            <div class="col-md review-col">
        <p class="reviewer">Jelmer_d, July 2025</p>
        <p class="review">Amazing diverse tour of Montenegro</p>
        <button
          class="btn btn-review-more"
          data-toggle="modal"
          data-target="#reviewModal70"
        >
          READ MORE
        </button>
      </div>
    </div>

        <div class="modal fade" id="reviewModal70">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title reviewer">
              Jelmer_d, July 2025
            </h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div class="modal-body modal-review">
            <p>Amazing diverse tour of Montenegro.</p>
            <span
              >I was only a few days in Montenegro, and I wanted to make them count. This tour did exactly that. The tour is very nicely balanced with a combination of natural, historical and urban sites. It was very comfortable and the guide Nino was amazing! With genuine interest for my interests and making sure that everything was well enjoyed he made this certainly one of the best tours I have been on! I 100% reccomend it.
            </span>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-natour-orange"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="reviewModal71">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title reviewer">
              Dorothy & John, July 2025
            </h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div class="modal-body modal-review">
            <p>Great private tour company at reasonable price</p>
            <span
              >Nino, the owner, designed the perfect private 5 day tour of Montenegro for us. He cleverly suggested we tour Kotor area on our own which reduced costs. He knows so many people in Montenegro that we visited the major national parks and dropped by inique Ecolodge, canyoning place, horseback riding place, 1 km long xip line, etc. so we learned how folks live in country which is why we travel. He designed a program taking us to the major sites. He designs too hiking trips, jeep tours et al. This is the travel agent to choose.
            </span>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-natour-orange"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="reviewModal72">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title reviewer">
              Andrei, July 2025
            </h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div class="modal-body modal-review">
            <p>Wonderful exploration of the beautiful Highlands of Montenegro</p>
            <span
              >You will really love this experience because Nino is an excellent tour guide with a lot of knowledge. He speaks English very well and knows a lot of history and is extremely thoughtful. He knows every place in Montenegro and will take you wherever you want to stop. It was a very meaningful experience to see some of the places and he's very detail oriented and knowledgeable. I would hire him to meet my private driver or to ask him for any advice on any tour at any time in montenegro. He's a real treasure.
            </span>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-natour-orange"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="reviewModal73">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title reviewer">
              BEATRICE_R, August 2025
            </h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div class="modal-body modal-review">
            <span
              >Tour riche en découverte et très intéressant. Nino est 1 guide très agréable, disponible et accessible. La visite a été adaptée a la suite de notre programme, pour éviter les doublons
            </span>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-natour-orange"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
        <div class="modal fade" id="reviewModal74">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title reviewer">
              Manwai, September 2025
            </h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div class="modal-body modal-review">
            <span
              >Our tour guide Nino was excellent. He was punctual, considerate to our needs and very knowledgeable about places we visited which help us to appreciate the stunning scenery and history of monentegro. Durmitor is beautiful and the drive around the mountains and villages gave us some spectacular views of monentegro. Overall we have a wonderful time with this day trip and the service from Nino.
            </span>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-natour-orange"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="reviewModal75">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title reviewer">
              Zsófia T, November 2025
            </h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div class="modal-body modal-review">
            <p>Great tour with insightful guidance</p>
            <span
              >Nino is an excellent, knowledgeable, and personable guide. He provided intriguing insights into history, culture, and local traditions. His flexibility regarding a requested change to the original itinerary was especially appreciated. He has my highest recommendation.
            </span>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-natour-orange"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

      <a href="/reviews" class="btn link-review-more">READ ALL REVIEWS</a>
    </div>
    <!-- <div class="text-xs-center">
      <v-menu
        min-width = 300
        top
        v-model="menu"
        :close-on-click="false"
        :close-on-content-click="false"
        :nudge-top="60"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-fab-transition>
            <v-btn
              v-model="fab"
              v-on="on"
              color='green darken-1'
              @click="fab = !fab; menu = false"
              dark
              fixed
              bottom
              right
              fab
            >
              <v-icon>comment</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-fab-transition>
        </template>
        <v-card>
          <v-list dark class="chat-header">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Contact me</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  icon
                  @click="fab = !fab; menu = false"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-container class="chat-background">
            <v-layout row wrap >
              <v-flex class="text-xs-right" xs12 mb-4>
                <v-chip class="chip-chat ">
                  Hello, how can we help you? <v-icon right>done_all</v-icon>
                </v-chip>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  single-line
                  color="teal"
                  class="my-input"
                  v-model="text"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn
                  large
                  class="teal--text"
                  icon
                  @click="fab = !fab; menu = false"
                  :href="apilink"
                  target="_blank"
                >
                  <v-icon large>send</v-icon>
                </v-btn>
               </v-flex>
             </v-layout>
          </v-container>
        </v-card>
      </v-menu>
    </div> -->
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  components: {
    Carousel,
    Slide
  }
}
</script>

<style scoped>
.slide-nav {
  font-size: 50px;
}

button.VueCarousel-navigation-next {
  right: 50px !important;
  /* transform: translateY(-50%) translateX(0)!important; */
}
.wrapper-parent {
  width: auto;
  /* margin-top:10vh; */
  padding-bottom: 10vh;
}
img {
  width: 100%;
}
.top-right-nat {
  position: absolute;
  top: 8px;
  right: 0px;
  background-color: rgb(113, 186, 107);
  border-radius: 3px 0px 3px 3px;
  padding: 3px;
  font-size: 1.2rem;
}
.top-right-cul {
  position: absolute;
  top: 8px;
  right: 0px;
  background-color: rgb(188, 109, 73);
  border-radius: 3px 0px 3px 3px;
  padding: 3px;
  font-size: 1.2rem;
}
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5vw;
  color: #ffffff;
  opacity: 1;
  font-weight: bold;
  width: 70vw;
  text-shadow: 2px 2px 1px #1d1d1d;
}

.centered-1 {
  text-shadow: 2px 2px 1px #4a744a;
}

div.centered-7 p {
  margin-bottom: -30px;
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 2vw;
}

/* Responsive layout - makes a two column-layout instead of four columns */
@media screen and (max-width: 800px) {
  .column {
    flex: 50%;
    max-width: 50%;
  }
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    flex: 100%;
    max-width: 100%;
  }
}

a:hover {
  background: greenyellow;
}
/* .pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
} */

.my-input.v-input .v-input__slot {
  border-radius: 100px;
}
.chat-background {
  background-color: #ece5dd !important;
}
.chat-header {
  background-color: #075e54 !important;
}
.chip-chat {
  background-color: #dcf8c6 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageSlider.vue